import React from "react";

interface FormCheckboxProps {
    id:string,
    checked: boolean,
    onChange: (status: boolean) => void,
    isDisabled?: boolean
}
 
interface FormCheckboxState {
    
}
 
class FormCheckbox extends React.Component<FormCheckboxProps, FormCheckboxState> {
    constructor(props:FormCheckboxProps){
        super(props)
    }

    onChangeHandler = () => this.props.onChange(!this.props.checked);

    render() { 
        return (
            <label htmlFor={this.props.id} className="checkbox-control">
                <input id={this.props.id} className="checkbox" type="checkbox" onChange={this.onChangeHandler} checked={this.props.checked} disabled={this.props.isDisabled} />
                <span className="checkbox-bg"></span>
                <span className="checkbox-cursor"></span>
            </label>
        );
    }
}
 
export default FormCheckbox;